import styled from 'styled-components';
import { Row as antdRow } from 'antd';

const Row = styled(antdRow)``;

export { Row };